import apiService from '../Api'
import { EventMachine } from './types'

export class EventMachineService {
  async generateActivationCode(eventId: number, name: string): Promise<{ code: string; expires_at: string }> {
    return apiService
      .post(`/events/${eventId}/machines/generate-activation-code`, { name })
      .then((response) => response.data)
  }

  async listMachines(eventId: number): Promise<EventMachine[]> {
    return apiService.get(`/events/${eventId}/machines`).then((response) => response.data)
  }

  async deactivateMachine(eventId: number, machineId: number): Promise<void> {
    await apiService.patch(`/events/${eventId}/machines/${machineId}/deactivate`)
  }

  async toggleAuction(eventId: number): Promise<{ action: string; auction_ends_at: string | null }> {
    return apiService.post(`/events/${eventId}/machines/toggle-auction`).then((response) => response.data)
  }
}
